import React from "react"
import { Stages } from "./Stages"
import styles from "./index.module.scss"

export const Main = () => {
    return (
        <div className={styles.container}>
            <Stages />
        </div>
    )
}
